import React, { Suspense } from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import App from "./containers/App";
import { store } from "./store";
render(
  <Provider store={store}>
    <Suspense fallback={<div>در حال بارگزاری ...</div>}>
      <App />
    </Suspense>
  </Provider>,
  document.getElementById("root")
);
